/* import __COLOCATED_TEMPLATE__ from './suggestion-implementation-item.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { type PulseAccordionSection } from 'glint/pulse';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Args: {
    section: PulseAccordionSection;
    sectionId: string;
    isOpen: boolean;
    reasoning: string | null;
    implementationDifficultyScore: number;
  };
}

type EffortColor = 'green' | 'yellow' | 'gray' | 'red';

export default class SuggestionImplementationItem extends Component<Signature> {
  @service declare intl: IntlService;

  get effort() {
    return this.resolveEffortLabel;
  }

  get formattedReasoning() {
    if (!this.args.reasoning) {
      return '';
    }
    return sanitizeHtml(this.args.reasoning);
  }

  get resolveEffortLabel(): { displayText: string; color: EffortColor } {
    if (this.args.implementationDifficultyScore === -1) {
      return {
        displayText: this.intl.t('automation.analyze.task-suggestions.effort-score.unknown'),
        color: 'yellow' as EffortColor,
      };
    }

    let effortLevel;
    let score = this.args.implementationDifficultyScore;

    if (score <= 2) {
      effortLevel = {
        displayText: this.intl.t('automation.analyze.task-suggestions.effort-score-v3.low'),
        color: 'green' as EffortColor,
      };
    } else if (score <= 4) {
      effortLevel = {
        displayText: this.intl.t('automation.analyze.task-suggestions.effort-score-v3.medium'),
        color: 'yellow' as EffortColor,
      };
    } else {
      effortLevel = {
        displayText: this.intl.t('automation.analyze.task-suggestions.effort-score-v3.high'),
        color: 'red' as EffortColor,
      };
    }

    return effortLevel;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SuggestionAccordionItems::SuggestionImplementationItem': typeof SuggestionImplementationItem;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-accordion-items/suggestion-implementation-item': typeof SuggestionImplementationItem;
  }
}
